import React, { useContext } from 'react';

import { Checkbox } from '@atlaskit/checkbox';

import { messages } from '@qality/common-messages';
import { TestStepsView } from '@qality/common-model';
import { StorageOfUniqueComponents } from '@qality/common-service';
import { TestExecutionPageContext } from '@qality/common-state';

import TestExecutionTableTestCaseHeader from './TestExecutionTableTestCaseHeader';
import TestExecutionTableTestExecutionHeader from './TestExecutionTableTestExecutionHeader';
import './_test-execution-details.scss';

type Props = {
  view: TestStepsView;
  selectAll?: boolean;
  onSelectAllChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

type ContextType = {
  canEdit: boolean;
};

// eslint-disable-next-line complexity
function TestExecutionTableHeader({
  view,
  selectAll,
  onSelectAllChange,
}: Props): JSX.Element {
  const { isDetailView } = view;

  const context: ContextType = useContext(TestExecutionPageContext);
  const TestExecutionColumnsWidth = StorageOfUniqueComponents.get(
    'TestExecutionColumnsWidth'
  );

  return (
    <div className='test-execution-headers-container'>
      <div className='test-steps-headers'>
        <TestExecutionTableTestCaseHeader
          shouldAddDetailsPrefix={view.isDetailView}
          label={messages['testCaseBoxStep.testStep.label']}
          additionalClassName='label-first'
        />
        {isDetailView && (
          <TestExecutionTableTestCaseHeader
            shouldAddDetailsPrefix={view.isDetailView}
            label={messages['testCaseBoxStep.testData.label']}
          />
        )}
        <TestExecutionTableTestCaseHeader
          shouldAddDetailsPrefix={view.isDetailView}
          label={messages['testCaseBoxStep.expectedResult.label']}
        />
        {isDetailView && (
          <TestExecutionTableTestCaseHeader
            shouldAddDetailsPrefix={view.isDetailView}
            label={messages['testCaseBoxStep.attachments.label']}
          />
        )}
        <div style={{ width: '2em' }}></div>
        <TestExecutionTableTestExecutionHeader
          label={messages['testCaseBoxStep.comment.label']}
          additionalClassName='label-first'
          columnName='commentColumn'
        />
        <TestExecutionTableTestExecutionHeader
          label={messages['testCaseBoxStep.attachments.label']}
          additionalClassName='label-first'
          columnName='attachementColumn'
        />
        <TestExecutionTableTestExecutionHeader
          label={messages['testCaseBoxStep.bugs.label']}
          additionalClassName='label-first'
          columnName='bugsColumn'
        />
        <TestExecutionTableTestExecutionHeader
          label={messages['testCaseBoxStep.status.label']}
          additionalClassName='label-first'
          columnName='statusColumn'
        />
        <div
          className='column-header checkbox-header-column'
          style={{ width: TestExecutionColumnsWidth.checkboxColumn }}
        >
          <Checkbox
            isChecked={selectAll}
            onChange={onSelectAllChange}
            isDisabled={!context.canEdit}
          />
        </div>
      </div>
    </div>
  );
}

export default TestExecutionTableHeader;
